import React, { useCallback, useEffect, useMemo } from 'react';
import { Form, Radio, Row } from 'antd';
import { useTranslation } from 'react-i18next';

type TypeOfContract = 1 | 2 | 4;

interface ITypeOfContractStepValues {
  typeOfContract: TypeOfContract | undefined;
}

interface ITypeOfContractStep {
  values: ITypeOfContractStepValues;
  onChange: (values: ITypeOfContractStepValues) => void;
}

const TypeOfContractStep = ({ values, onChange }: ITypeOfContractStep) => {
  const { t } = useTranslation(['attributes', 'contracts']);
  const [form] = Form.useForm();
  const typeOfContractValue = Form.useWatch('typeOfContract', form);

  const showChargedByOperatorInput =
    typeOfContractValue && typeOfContractValue !== 4;

  useEffect(() => {
    if (values) {
      form.setFieldsValue(values);
    }
  }, [form, values]);

  const typeOptions = useMemo(
    () => [
      {
        label: t('type.sharedWithout'),
        value: 1,
      },
      {
        label: t('type.sharedTotal'),
        value: 2,
      },
      // {
      //   label: t('type.payPerUse'),
      //   value: 4,
      // },
    ],
    [t],
  );

  const handleOnValuesChange = useCallback(
    (changedValue: TypeOfContract, allValues: ITypeOfContractStepValues) => {
      const isTypeOfContractChanged =
        Object.keys(changedValue)[0] === 'typeOfContract';
      if (isTypeOfContractChanged) {
        form.setFieldValue('chargedByOperator', undefined);
      }
      onChange(allValues);
    },
    [form, onChange],
  );

  return (
    <Form form={form} onValuesChange={handleOnValuesChange} layout="vertical">
      <Row gutter={[16, 16]} justify="center">
        <Form.Item
          name="typeOfContract"
          style={{ marginBottom: showChargedByOperatorInput ? 24 : 0 }}
        >
          <Radio.Group optionType="button" options={typeOptions} />
        </Form.Item>
      </Row>
    </Form>
  );
};

export default TypeOfContractStep;
